var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",attrs:{"href":_vm.url},on:{"click":function($event){$event.preventDefault();_vm.go($event)}}},[_vm._v("Feature request")])}
var staticRenderFns = []

export { render, staticRenderFns }